export default __webpack_public_path__ + "static/media/gold-fishes-mob.1d8d2519.png";